import {
  CREATE_GREETING_BACKEND,
  CREATE_NEW_FEEDBACKS,
  CREATE_QUICK_PRACTICE,
  CreateSimulation,
  CreateFeedbacks,
  EditProfile,
  EditSimulation,
  EditUserImage,
  FEEDBACKS,
  GENERATE_NEW_FEEDBACKS,
  GET_LAST_SIMULATION,
  GET_PRACTICE,
  GET_SIMULATION,
  GET_SIMULATION_ID,
  GetSimulationById,
  GET_SIMULATION_BY_USER,
  GetSimulation,
  GetSimulationByUser,
  GetFeedbacks,
  HttpRequest,
  LatSimulation,
  MARK_FORUM_EDIT,
  MARK_FORUM_LIKE,
  QuickPractice,
  RequestMethod,
  SAVE_GREETING_BACKEND,
  SAVE_NEW_FEEDBACKS,
  SaveGreeting,
  WEB_SCRAPPING,
  GetSimulationByIdInDashboard,
  GET_SIMULATION_ID_DASHBOARD,
  createGreetingBackPyth,
  GenerateFeedback,
  InSumlationFeedback,
  WebScraping,
  EDIT_PROFILE,
  EDIT_IMAGE,
  GetPractice,
  GetCoachTivy,
  DELETE_SIMULATION,
  DeleteSimulationById,
  GET_COACH_TIVY,
  STORE_SIMULATION_RATING,
  SimulationRating,
  GET_SIMULATION_RATING,
  CREATE_COACH_TIVY_FEEDBACKS,
  CreateCoachTivyFeedbacks,
  GET_COACH_TIVY_FEEDBACKS,
  GetCoachTivyFeedbacks,
  GetTranscription,
  GET_TRANSCRIPTION,
  GET_DONOR_SIMULATION_FEEDBACKS,
  GetDonorSimulationFeedbacks,
  CREATE_DONOR_SIMULATION_FEEDBACKS,
  CreateDonorSimulationFeedbacks,
  SAVE_TRANSCRIPTION,
  SaveTranscription,
  SAVE_VAPI_ASSISTANT
} from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

interface HttpResponse<T> {
  status: number;
  result: T;
  message: string;
  success: false;
}
interface SimulationData {
  _id: string;
  simulationTitle: string;
  donorType: string;
  practiceType: string;
  goals: string[];
  assistantId: string[];
  callId: string[];
  provider: string;
  voiceId: string;
  user: string;
  createdAt: string;
  updatedAt: string;
}

interface FeedbackData {
  _id: string;
  Feedback: string;
  simulationId: string;
  user: string;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse {
  status: boolean;
  data: {
    simulation: SimulationData;
    feedback: FeedbackData;
  };
}

export const createSimulation = createAsyncThunk(MARK_FORUM_LIKE, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: CreateSimulation,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create simulation');
  }
});

export const editSimulation = createAsyncThunk(MARK_FORUM_EDIT, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: `${EditSimulation}?id=${payload?.send_Data?.id}`, // Append the ID to the endpoint
      body: payload?.send_Data?.payload,
      method: RequestMethod.POST
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to edit simulation');
  }
});

export const getSimulation = createAsyncThunk(GET_SIMULATION, async () => {
  try {
    const response = (await HttpRequest({
      url: GetSimulation,
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get simulation');
  }
});

export const getSimulationByUser: any = createAsyncThunk(
  GET_SIMULATION_BY_USER,
  async ({ page, limit, userId }: { page: number; limit: number; userId: string }) => {
    try {
      const response: any = (await HttpRequest({
        url: `${GetSimulationByUser}?page=${page}&limit=${limit}`,
        method: RequestMethod.POST,
        body: { userId } // Ensure userId is passed as an object
      })) as HttpResponse<any>;

      return response;
    } catch (error: unknown) {
      throw new Error(error instanceof Error ? error.message : 'Failed to get simulation by user');
    }
  }
);

export const getSimulationById = createAsyncThunk<
  HttpResponse<any>, // The type of the return value
  string // The type of the first argument
>(GET_SIMULATION_ID, async (simulationId: string) => {
  try {
    const response = (await HttpRequest({
      url: `${GetSimulationById}?id=${simulationId}`, // Append the ID to the endpoint
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get simulation by id');
  }
});

export const getSimulationByIdDashboard = createAsyncThunk(
  GET_SIMULATION_ID_DASHBOARD,
  async ({ simulationId, userId }: { simulationId: string; userId: string }) => {
    try {
      const response = (await HttpRequest({
        url: `${GetSimulationByIdInDashboard}/${simulationId}`,
        body: { userId }, // Ensure userId is passed as an object
        method: RequestMethod.POST
      })) as ApiResponse;

      if (response.status) {
        return response.data; // Return the fetched data
      } else {
        throw new Error('Failed to fetch simulation data');
      }
    } catch (error) {
      throw new Error((error as Error).message || 'An error occurred while fetching the simulation data');
    }
  }
);

export const inSimulationFeedback = createAsyncThunk(FEEDBACKS, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: InSumlationFeedback,
      method: RequestMethod.POST,
      body: { previousConversationHistory: payload }
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get simulation by id');
  }
});

export const generateSimulationFeedback = createAsyncThunk(GENERATE_NEW_FEEDBACKS, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: GenerateFeedback,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to generate simulation feedback');
  }
});

export const editUserProfile = createAsyncThunk(EDIT_PROFILE, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: EditProfile,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;
    if (response?.status) {
      // toast.success('Profile updated successfully.',{toastId:'a31'});
      return response;
    } else {
      toast.error(response?.message, { toastId: 'a32' });
      return;
    }
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to edit user profile');
  }
});

export const editUserImage = createAsyncThunk(EDIT_IMAGE, async (payload: any) => {
  try {
    const formData = new FormData();

    // Append the image file and other user data
    formData.append('file', payload);

    const response = (await HttpRequest({
      url: EditUserImage,
      method: RequestMethod.POST,
      body: formData
    })) as HttpResponse<any>;
    if (response?.status) {
      // toast.success('User profile updated successfully.',{toastId:'a33'});
      return response;
    } else {
      toast.error(response?.message, { toastId: 'a34' });
      return;
    }
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to edit user image');
  }
});

export const createSimulationFeedbacks = createAsyncThunk(CREATE_NEW_FEEDBACKS, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: CreateFeedbacks,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create simulation feedback');
  }
});

export const createCoachTivyFeedbacks = createAsyncThunk(CREATE_COACH_TIVY_FEEDBACKS, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: CreateCoachTivyFeedbacks,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create simulation feedback');
  }
});

export const getCoachTivyFeedbacks = createAsyncThunk(GET_COACH_TIVY_FEEDBACKS, async (simulationId: any) => {
  try {
    const response = (await HttpRequest({
      url: GetCoachTivyFeedbacks.replace('simulation_id', simulationId),
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get coach tivy feedbacks');
  }
});

export const saveTranscription = createAsyncThunk(SAVE_TRANSCRIPTION, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: SaveTranscription,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to save transcription');
  }
});

export const createDonorSimulationFeedbacks = createAsyncThunk(
  CREATE_DONOR_SIMULATION_FEEDBACKS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: CreateDonorSimulationFeedbacks,
        method: RequestMethod.POST,
        body: payload
      })) as HttpResponse<any>;

      return response;
    } catch (error: unknown) {
      throw new Error(error instanceof Error ? error.message : 'Failed to create donor simulation feedback');
    }
  }
);

export const getDonorSimulationFeedbacks = createAsyncThunk(
  GET_DONOR_SIMULATION_FEEDBACKS,
  async (simulationId: any) => {
    try {
      const response = (await HttpRequest({
        url: GetDonorSimulationFeedbacks.replace('simulation_id', simulationId),
        method: RequestMethod.GET
      })) as HttpResponse<any>;

      return response;
    } catch (error: unknown) {
      throw new Error(error instanceof Error ? error.message : 'Failed to get donor simulation feedbacks');
    }
  }
);

export const getSimulationFeedbacks = createAsyncThunk(SAVE_NEW_FEEDBACKS, async (id: any) => {
  try {
    const response = (await HttpRequest({
      url: `${GetFeedbacks}?id=${id}`, // Append the ID to the endpoint
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get simulation feedback');
  }
});

export const createQuickPratice = createAsyncThunk(CREATE_QUICK_PRACTICE, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: QuickPractice,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;
    if (response?.success) {
      toast.success(response?.message, { toastId: 'a35' });
    }

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create quick practice');
  }
});

export const getQuickPratice = createAsyncThunk(GET_PRACTICE, async () => {
  try {
    const response = (await HttpRequest({
      url: GetPractice, // Append the ID to the endpoint
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get quick practice');
  }
});

export const getCoachTivy = createAsyncThunk(GET_COACH_TIVY, async () => {
  try {
    const response = (await HttpRequest({
      url: GetCoachTivy,
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get coach tivy');
  }
});

export const createWebScraping = createAsyncThunk(WEB_SCRAPPING, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: WebScraping,
      method: RequestMethod.POST,
      body: { url: payload }
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create greeting');
  }
});

export const getLastSimulation = createAsyncThunk(GET_LAST_SIMULATION, async () => {
  try {
    const response = (await HttpRequest({
      url: LatSimulation,
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create greeting');
  }
});

export const createGreetingPyth = createAsyncThunk(CREATE_GREETING_BACKEND, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: createGreetingBackPyth,
      method: RequestMethod.POST,
      body: { feedback: payload }
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to create greeting');
  }
});

export const saveGreeting = createAsyncThunk(SAVE_GREETING_BACKEND, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: SaveGreeting,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to save greeting');
  }
});

export const deleteSimulationById = createAsyncThunk(DELETE_SIMULATION, async (simulationId: any) => {
  try {
    const response = (await HttpRequest({
      url: `${DeleteSimulationById}?id=${simulationId}`,
      method: RequestMethod.DELETE
    })) as HttpResponse<any>;
    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to delete simulation');
  }
});

export const storeSimulationRating = createAsyncThunk(STORE_SIMULATION_RATING, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: SimulationRating.replace('simulation_id', payload?.simulationId),
      method: RequestMethod.POST,
      body: {
        rating: payload?.rating,
        description: payload?.description
      }
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to save simulation rating');
  }
});

export const getSimulationRating = createAsyncThunk(GET_SIMULATION_RATING, async (simulationId: any) => {
  try {
    const response = (await HttpRequest({
      url: SimulationRating.replace('simulation_id', simulationId),
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get simulation rating');
  }
});

export const getTranscription = createAsyncThunk(GET_TRANSCRIPTION, async (simulationId: any) => {
  try {
    const response = (await HttpRequest({
      url: GetTranscription.replace('simulation_id', simulationId),
      method: RequestMethod.GET
    })) as HttpResponse<any>;

    return response;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to get transcription');
  }
});

export const saveVapiAssistant = createAsyncThunk(SAVE_VAPI_ASSISTANT, async (payload: any) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${import.meta.env.VITE_VAPI_TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: payload
    };

    const res = await fetch(import.meta.env.VITE_VAPI_PLAY ?? '', options);
    const data = await res.json();

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : 'Failed to save transcription');
  }
});
